// client\src\pages\produzir.jsx

import { useState, useMemo, useEffect } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/notifications.css';
import CreateCliente from '../components/Usuarios/CreateCliente';
import { isAuthenticated } from '../../src/index'
import notifications from '../components/notifications';
import ReactCountryFlag from "react-country-flag";



const FlagLabel = ({ countryCode, text }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
    <ReactCountryFlag
      countryCode={countryCode}
      svg
      style={{ fontSize: "1.5em" }}
      aria-label={countryCode}
    />
    <span>{text}</span>
  </span>
);


// Sugestões de preenchimento automático para o campo "Observações"
function getObsAutoFillOptions() {
  return [
    "Processo individual completo.",
    "Processo em família.",
    "Cliente em contato pelo WhatsApp.",
    "Ainda não efetuou pagamento da assessoria.",
    "Já efetuou o pagamento da assessoria.",
    "Falta agora preencher o nosso formulário online e depois fazer a primeira vídeo chamada de análise.",
  ];
}





function Produzir() {
  const [notificationType, setNotificationType] = useState(0);
  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType, setNotificationType]);
  /* Variáveis de cadastro PRODUCAO */
  const [servicesError, setServicesError] = useState(false);
  const [vendedorError, setVendedorError] = useState(false);
  const [produtorError, setProdutorError] = useState(false);

  const [nome, setNome] = useState("");
  const [contato, setContato] = useState("");
  const [dsAdulto, setDsAdulto] = useState(0);
  const [dsKids, setDsKids] = useState(0);
  const [australiaForm, setAustraliaForm] = useState(0);
  const [i140Form, setI140Form] = useState(0);
  const [canadaForm, setCanadaForm] = useState(0);

  const [passport, setPassport] = useState(0);
  const totalForms = (Number(dsAdulto) || 0) + (Number(dsKids) || 0) + (Number(passport) || 0);
  const [preenchendo, setPreenchendo] = useState(0);
  const [obsProd, setObsProd] = useState("");
  const [produtor, setProdutor] = useState(0);
  const [statusProd, setStatusProd] = useState(0);
  const [vendedorProd, setVendedorProd] = useState("");
  const [analise, setAnalise] = useState(0);
  const [dataCadastro, setDataCadastro] = useState(`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`);
  const [dataProduzindo, setDataProduzindo] = useState(`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`);
  const [dataEntregue, setDataEntregue] = useState(`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`);
  const [formularioProd, setFormularioProd] = useState("");
  const [analiseProd, setAnaliseProd] = useState("");
  const [ClienteId, setClienteId] = useState("");
  const [clienteError, setClienteError] = useState(false);

  const [colaboradoresSel, setColaboradoresSel] = useState([]);
  const [colabOptions, setColabOptions] = useState([]);


  const [comprovanteNome, setComprovanteNome] = useState("");
  const [comprovanteContato, setComprovanteContato] = useState("");
  const [comprovanteDsAdulto, setComprovanteDsAdulto] = useState(0);
  const [comprovanteDsKids, setComprovanteDsKids] = useState(0);
  const [comprovanteCanadaForm, setComprovanteCanadaForm] = useState(0);

  const [comprovantePassport, setComprovantePassport] = useState(0);
  const [comprovantePreenchendo, setComprovantePreenchendo] = useState(0);
  const [comprovanteObsProd, setComprovanteObsProd] = useState("");
  const [comprovanteProdutor, setComprovanteProdutor] = useState(0);
  const [comprovanteStatusProd, setComprovanteStatusProd] = useState(0);
  const [comprovanteVendedorProd, setComprovanteVendedorProd] = useState("");
  const [comprovanteAnalise, setComprovanteAnalise] = useState(0);
  const [dataCadastroComprovante, setDataCadastroComprovante] = useState("");
  const [dataProduzindoComprovante, setDataProduzindoComprovante] = useState("");
  const [dataEntregueComprovante, setDataEntregueComprovante] = useState("");
  const [comprovanteAnaliseProd, setComprovanteAnaliseProd] = useState("");
  const [comprovanteFormularioProd, setComprovanteFormularioProd] = useState("");

  const [usersListProd, setUsersListProd] = useState([]);
  const [clientesList, setClientesList] = useState([]);
  const [parceirosList, setParceirosList] = useState([]);

  const [estadoFormulario, setEstadoFormulario] = useState(false);
  const [estadoAnalise, setEstadoAnalise] = useState(false);
  const [comprovanteEnviadoProd, setComprovanteEnviadoProd] = useState(false);

  const [isModalOpenForm, setIsModalOpenForm] = useState(false);
  const [currentFormContent, setCurrentFormContent] = useState('');

  const [isModalOpenAnalise, setIsModalOpenAnalise] = useState(false);
  const [currentAnaliseContent, setCurrentAnaliseContent] = useState(''); // Conteúdo da análise de perfil
  const [comprovanteFormularioLinks, setComprovanteFormularioLinks] = useState([]);
  const [uniqueClientLink, setUniqueClientLink] = useState([]);

  const [vendedoresList, setVendedoresList] = useState([]);
  const [produtoresList, setProdutoresList] = useState([]);
  const [formularioSimples, setFormularioSimples] = useState(false);

  const [filteredDataProd, setFilteredDataProd] = useState([]);
  /////////////////////////////////

  const [showAllClientes, setShowAllClientes] = useState(false);


  const obsAutoFillOptions = useMemo(() => getObsAutoFillOptions(), []);
  // Lista dinâmica (some conforme usa)
  const [obsSuggestions, setObsSuggestions] = useState(getObsAutoFillOptions());


  // Insere a frase nas observações (concatenando com quebra de linha)
  const handleAddObsSnippet = (snippet) => {
    // 1. Insere nas observações
    setObsProd((prev) => {
      if (!prev || prev.trim() === "") return snippet;
      return `${prev.trim()}\n${snippet}`;
    });

    // 2. Remove a sugestão da lista
    setObsSuggestions((prev) => prev.filter(item => item !== snippet));
  };





  const [clienteDetails, setClienteDetails] = useState(null);
  async function getClienteDetails(clienteID) {
    if (!clienteID) {
      console.log("ClienteID é inválido ou não fornecido");
      return; // Retorna antecipadamente se clienteID for inválido
    }
    try {
      console.log("ClienteID:", clienteID);
      const response = await api.get(`/clienteAgiliza/${clienteID}`);
      setClienteDetails(response.data);
      setNome(response.data.Nome);
      setContato(response.data.contato);
      console.log("infos seguidas " + response.data.Nome);
    } catch (error) {
      console.error("Error fetching client details", error);
    }
  }
  useEffect(() => {
    getClienteDetails(ClienteId);
  }, [ClienteId]);
  async function getUsers() {
    const resCliente = await api.get('/clientesAgiliza');
    const resProd = await api.get('/clientesProd');
    const resParceiro = await api.get('/clientesParceiros');
    setParceirosList(resParceiro.data);
    setUsersListProd(resProd.data);
    setFilteredDataProd(resProd.data);
    setClientesList(resCliente.data);
  }
  const getVendedoresProdutores = async () => {
    try {
      const resVendedoresProdutores = await api.get('/vendedores-produtores');
      // Verifica se a resposta possui a chave `data`
      if (resVendedoresProdutores.data && Array.isArray(resVendedoresProdutores.data.data)) {
        const users = resVendedoresProdutores.data.data;
        // console.log('Vendedores e Produtores carregados:', users);
        setVendedoresList(users.filter(user => user.is_vendedor === 1));
        setProdutoresList(users.filter(user => user.is_produtor === 1));


        // todos os usuários desse endpoint podem ser colaboradores
        // remove duplicados por CPF
        const uniq = [];
        const byCpf = new Set();
        for (const u of users) {
          const cpf = String(u.cpf || '').replace(/\D/g, '');
          if (!byCpf.has(cpf) && cpf) { byCpf.add(cpf); uniq.push({ ...u, cpf }); }
        }
        setColabOptions(uniq);




      } else {
        console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
        NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      NotificationManager.error('Erro ao carregar dados.', 'Erro');
    }
  }

  useEffect(() => {
    getVendedoresProdutores();
    getUsers();
  }, []);

  const handleCheckBoxChange = (event) => {
    // if (event.target.id === "checkBox7") { // Verifica se o checkbox 6 foi alterado
    //   if (event.target.checked) {
    //     setPreenchendo(1); // Se o checkbox 6 estiver marcado, define Pago como 1
    //   } else {
    //     setPreenchendo(0); // Se o checkbox 6 não estiver marcado, define Pago como 0
    //   }
    // }
    if (event.target.id === "checkBox8") { // Verifica se o checkbox 6 foi alterado
      if (event.target.checked) {
        setAnalise(1); // Se o checkbox 6 estiver marcado, define Pago como 1
      } else {
        setAnalise(0); // Se o checkbox 6 não estiver marcado, define Pago como 0
      }
    }
  }
  /* Faz a verificação de todos os campos para saber se estão vazios ou preenchidos. */
  const validateFormProd = () => {
    let hasError = false;

    // serviços
    if ((Number(dsAdulto) || 0) + (Number(dsKids) || 0) + (Number(canadaForm) || 0) + (Number(australiaForm) || 0) + (Number(i140Form) || 0) + (Number(passport) || 0) === 0) {
      setServicesError(true);
      hasError = true;
    } else {
      setServicesError(false);
    }

    // vendedor
    if (!String(vendedorProd || '').trim()) {
      setVendedorError(true);
      hasError = true;
    } else {
      setVendedorError(false);
    }

    // produtor (se é obrigatório)
    if (!String(produtor || '').trim()) {
      setProdutorError(true);
      hasError = true;
    } else {
      setProdutorError(false);
    }

    // cliente
    if (ClienteId === "" || ClienteId === 0) {
      setClienteError(true);
      hasError = true;
      setNotificationType(20);
    } else {
      setClienteError(false);
    }

    if (hasError) {
      setNotificationType(3); // sua notificação de "campos vazios"
      return false;
    }

    return true;
  };

  /* Insere os dados somente se todos os campos requeridos estiverem preenchidos. */
  const insertDataProd = async () => {
    console.log("cliente erro6")
    if (validateFormProd()) {
      // let checkBox7 = document.getElementById("checkBox7");
      let checkBox8 = document.getElementById("checkBox8");
      const formattedFormularios = formularioProd.length === 0 || formularioProd.every(form => form.trim() === '')
        ? Array.from({ length: totalForms }, (_, i) => `FORM ${i + 1}`)
        : formularioProd;

      const data = {
        dsAdulto,
        dsKids,
        canadaForm,
        i140Form,
        australiaForm,

        passport,
        preenchendo: false,
        obsProd,
        produtor,
        statusProd,
        vendedorProd,
        analise: checkBox8.checked ? 1 : 0,
        dataCadastro: new Date().toISOString().split('T')[0],
        dataProduzindo: null,
        dataEntregue: null,
        analiseProd,
        formularioProd: formattedFormularios,
        ClienteId: ClienteId,
        colaboradores: colaboradoresSel
      };

      const res = await api.post('/cadastrarProd', data);
      if (res.data.status === true) {
        setNotificationType(1);
        getUsers();
        // Obtem a origem dinamicamente
        // const origin = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
        const origin = `${window.location.protocol}//${window.location.hostname}`;
        const uniqueClientLink = `${origin}/formularios/${ClienteId}`;

        // Atualiza a lista de links para preenchimento individual dos formulários
        const formularioLinks = res.data.formularios.map(form => ({
          id: form.id,
          tipo: form.tipo,
          link: `${origin}/preencher/${form.id}`
        }));

        setComprovanteFormularioLinks(formularioLinks); // Salva os links dos formulários individuais
        setUniqueClientLink(uniqueClientLink); // Salva o link único do cliente
        setComprovanteEnviadoProd(true);
        setComprovanteFormularioLinks(formularioLinks); // Salva os links gerados
        setComprovanteEnviadoProd(true);
        setComprovanteNome(nome);
        setComprovanteContato(contato);
        setComprovanteDsAdulto(dsAdulto);
        setComprovanteDsKids(dsKids);
        setComprovanteCanadaForm(canadaForm);

        setComprovantePassport(passport);
        setComprovanteObsProd(obsProd);
        setComprovanteProdutor(produtor);
        setComprovanteStatusProd(statusProd);
        setComprovanteVendedorProd(vendedorProd);
        setDataCadastroComprovante(dataCadastro);
        setDataProduzindoComprovante(dataProduzindo);
        setDataEntregueComprovante(dataEntregue);
        setComprovanteAnaliseProd(analiseProd);
        setComprovanteAnalise(checkBox8.checked ? 1 : 0);
        setComprovantePreenchendo(false);
        setComprovanteFormularioProd(formularioProd);
        setColaboradoresSel([]); // limpar após sucesso

        clearDataProd();
      } else {
        setNotificationType(2);
      }
    }
    else {
      // setNotificationType(3);
    }
  };

  /* Limpa todos os campos após cadastro ser realizado com sucesso! */
  const clearDataProd = () => {
    console.log("limpou")
    setDsAdulto(0);
    setDsKids(0);
    setCanadaForm(0);

    setI140Form(0);
    setAustraliaForm(0);
    setPassport(0);
    setObsProd("");
    setProdutor(0);
    setStatusProd(0);
    setVendedorProd("");
    setAnaliseProd("");
    setFormularioProd("");
    document.getElementById("checkBox8").checked = false;
    setEstadoAnalise(false)
    setEstadoFormulario(false)
    setColaboradoresSel([]);
  }

  const handleToggleShowAll = () => {
    setShowAllClientes(prevState => !prevState);
  };
  const handleClienteSelecionado = (clienteId) => {
    setClienteId(clienteId);
    console.log('Cliente selecionado ID:', clienteId);
  };

  const handleTextareaChange = (index, value) => {
    const newFormularioProd = [...formularioProd];
    newFormularioProd[index] = value;
    setFormularioProd(newFormularioProd);
  };

  async function handleClienteCriado(novoCliente) {
    setClientesList((prevList) => [...prevList, novoCliente]); // Atualiza a lista com o novo cliente
    console.log("CLIENTE CRIADO id: " + novoCliente.id)
    handleClienteSelecionado(novoCliente.id); // Seleciona automaticamente o cliente recém-criado
    setClienteId(novoCliente.id)
  }

  // opções disponíveis (não mostra vendedor/produtor)
  const availableColabOptions = useMemo(() => {
    const vend = String(vendedorProd || '').replace(/\D/g, '');
    const prod = String(produtor || '').replace(/\D/g, '');
    return colabOptions.filter(u => u.cpf !== vend && u.cpf !== prod);
  }, [colabOptions, vendedorProd, produtor]);

  // se mudar vendedor/produtor, remove-os da seleção
  useEffect(() => {
    const vend = String(vendedorProd || '').replace(/\D/g, '');
    const prod = String(produtor || '').replace(/\D/g, '');
    setColaboradoresSel(prev => prev.filter(cpf => cpf !== vend && cpf !== prod));
  }, [vendedorProd, produtor]);

  const toggleColaborador = (rawCpf) => {
    const cpf = String(rawCpf).replace(/\D/g, '');
    setColaboradoresSel(prev =>
      prev.includes(cpf) ? prev.filter(c => c !== cpf) : [...prev, cpf]
    );
  };

  // Chip contador igual ao do financeiro: clicou -> vira "- qnt +"
  const Counter = ({ label, value, setValue }) => {
    const qnt = Number(value) || 0;
    const ativo = qnt > 0;

    const inc = () => setValue(qnt + 1);
    const dec = () => setValue(Math.max(0, qnt - 1));

    if (!ativo) {
      // Estado "inativo": chip clicável para iniciar em 1
      return (
        <div
          className={styles.servicosAgil}
          onClick={() => setValue(1)}
          title={`Adicionar 1 em ${label}`}
        >
          {label}
          {/* <div>(clique para adicionar)</div> */}
        </div>
      );
    }

    // Estado "ativo": mostra controles
    return (
      <div className={styles.servicosAgilClic}>
        <p>{label}</p>
        <div className={styles.servicosAgilClicDiv}>
          <button className={styles.buttonQuadrado} onClick={dec}>-</button>
          <p style={{ fontSize: "1rem" }}>{qnt}</p>
          <button className={styles.buttonQuadrado} onClick={inc}>+</button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const anyService = (Number(dsAdulto) || 0) + (Number(dsKids) || 0) + (Number(australiaForm) || 0) + (Number(i140Form) || 0) + (Number(canadaForm) || 0) + (Number(passport) || 0);
    if (anyService > 0 && servicesError) setServicesError(false);
  }, [dsAdulto, dsKids, passport, servicesError, canadaForm, i140Form, australiaForm]);


  return (
    <div className={styles.app}>
      <NotificationContainer />
      <div className={`${styles.corTitulo} ${styles.green}`}>
        <p className={styles.titulo}>CLIENTES</p>
      </div>
      <div className={styles.cadastroClienteContainer}>
        <CreateCliente
          clientesList={clientesList}
          onClienteCriado={handleClienteCriado}
          handleToggleShowAll={handleToggleShowAll}
          showAllClientes={showAllClientes}
          parceirosList={parceirosList}
          onClienteSelecionado={handleClienteSelecionado}
          errorCliente={clienteError}
        />
      </div>
      <div className={`${styles.corTitulo} ${styles.green}`}>
        <p className={styles.titulo}>PRODUÇÃO DS-160</p>
      </div>
      <div className={styles.cadastroClienteContainer}>
        {/* Parte 01 cadastro */}
        <div className={styles.containerVendedorInput} style={{ paddingTop: "15px", display: "flex", flexDirection: "column", alignItems: "center" }}>





          <div className={styles.rowTwoCols}>
            <div className={styles.containerVendedor}>
              <select
                onChange={(e) => { setVendedorProd(e.target.value); setVendedorError(false); }}
                value={vendedorProd}
                className={`${styles.inputFilter} ${styles.fullWidth} ${vendedorError ? styles.errorBorder : ''}`}
              >
                <option value="">Vendedor</option>
                {vendedoresList.map((v) => (
                  <option key={v.id} value={v.cpf} style={{ fontSize: '24px', fontWeight: 'bold' }}>
                    {v.nome}
                  </option>
                ))}
              </select>

            </div>

            <div className={styles.containerVendedor}>
              <select
                onChange={(e) => { setProdutor(e.target.value); setProdutorError(false); }}
                value={produtor}
                className={`${styles.inputFilter} ${styles.fullWidth} ${produtorError ? styles.errorBorder : ''}`}
              >
                <option value="">Produtor</option>
                {produtoresList.map((p) => (
                  <option key={p.id} value={p.cpf} style={{ fontSize: '24px', fontWeight: 'bold' }}>
                    {p.nome}
                  </option>
                ))}
              </select>

            </div>
          </div>






          <div className={styles.containerVendedor} style={{ paddingTop: 10 }}>
            <p className={styles.inputText}>ADCIONE COLABORADORES:</p>

            <div
              className={styles.colabGrid}
              style={{
                display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center'
              }}
            >
              {availableColabOptions.map(u => {
                const selected = colaboradoresSel.includes(u.cpf);
                return (
                  <button
                    key={u.cpf}
                    type="button"
                    onClick={() => toggleColaborador(u.cpf)}
                    aria-pressed={selected}
                    className={`${styles.colabButton} ${selected ? styles.colabButtonSelected : ''}`}
                    style={{
                      // fallback no inline (caso ainda não tenha adicionado no CSS module)
                      padding: '8px 8px',
                      borderRadius: 8,
                      border: '4px solid var(--corPrimaria)',
                      cursor: 'pointer',
                      background: selected ? 'var(--corPrimaria)' : 'transparent',
                      color: selected ? 'var(--onPrimary, #fff)' : 'inherit',
                      transition: 'background .15s ease, color .15s ease, border-color .15s ease',
                      fontWeight: 'bold',

                    }}
                    title={`${u.nome} - ${u.cpf}`}
                  >
                    {u.nome}
                  </button>
                );
              })}
            </div>
          </div>



          <div className={styles.containerVendedorInput}  >

            <div className={styles.cityContainer} style={{ paddingTop: "10px" }}>
              <label className={styles.containerCb}>
                <input id="checkBox8" type="checkbox" onChange={() => (setEstadoAnalise(!estadoAnalise), handleCheckBoxChange)} name="translateRadio" />
                <span className={styles.checkmark}></span>
              </label>
              <p className={styles.cidadeText}>Fez análise Perfil (Anotações sobre o perfil)</p>
            </div>
          </div>
          {/* Parte 03 cadastro */}
          <p className={styles.inputText} style={{ margin: 10 }}>--------------- FORMULARIOS ---------------</p>
          <div className={`${styles.cadastroItems06} ${servicesError ? styles.errorBorder : ''}`}>

            <Counter
              label={<FlagLabel countryCode="US" text="DS-160 (Adulto)" />}
              value={dsAdulto}
              setValue={setDsAdulto}
            />
            <Counter
              label={<FlagLabel countryCode="US" text="DS-160 (Criança)" />}
              value={dsKids}
              setValue={setDsKids}
            />
            <Counter
              label={<FlagLabel countryCode="CA" text="VISTO CANADÁ" />}
              value={canadaForm}
              setValue={setCanadaForm}
            />
            <Counter
              label={<FlagLabel countryCode="BR" text="PASSAPORTE" />}
              value={passport}
              setValue={setPassport}
            />
          </div>



          <div className={styles.divisor}></div>
          <p className={styles.inputText} style={{ margin: 10 }}>---------------  OBSERVAÇÕES  ---------------</p>

          <div className={styles.cadastroItems04}>
            <div className={styles.itemContainer}>
              {/* <p className={styles.inputText}>Observações:</p> */}

              <textarea onChange={(e) => setObsProd(e.target.value)} value={obsProd} className={styles.textArea} placeholder="Deixe uma observação sobre o cliente" ></textarea>
            </div>
          </div>



          {obsSuggestions.length > 0 && (
            <>
              <p className={styles.inputText} style={{ marginTop: 5, marginBottom: 5 }}>
                Sugestões rápidas:
              </p>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "6px",
                  marginBottom: "10px"
                }}
              >
                {obsSuggestions.map((snippet, idx) => (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => handleAddObsSnippet(snippet)}
                    className={styles.colabButton}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "12px",
                      border: "1px solid var(--corPrimaria)",
                      background: "white",
                      cursor: "pointer",
                      fontSize: "0.8rem",
                      maxWidth: "180px",
                      whiteSpace: "normal",
                      textAlign: "left",
                    }}
                  >
                    {snippet}
                  </button>
                ))}
              </div>
            </>
          )}


          {estadoAnalise === true ?
            <div className={styles.cadastroItems04}>
              <div className={styles.itemContainer}>
                <p className={styles.inputText}>Analise de Perfil:</p>
                <textarea onChange={(e) => setAnaliseProd(e.target.value)} value={analiseProd} className={styles.textArea} placeholder="Digite a Analise de perfil do cliente" ></textarea>
              </div>
            </div>
            :
            <></>
          }
          {estadoFormulario && (
            <div className={styles.cadastroItems04}>
              {Array.from({ length: totalForms }).map((_, index) => (
                <div className={styles.itemContainer} key={index}>
                  <p className={styles.inputText}>Formulário  ({index + 1})</p>
                  <textarea
                    onChange={(e) => handleTextareaChange(index, e.target.value)}
                    value={formularioProd[index] || ''}
                    className={styles.textArea}
                    placeholder="Formulario preenchido pelo cliente"
                  ></textarea>
                </div>
              ))}
            </div>
          )}
          <div className={styles.buttonContainer}>
            <button onClick={() => {
              setStatusProd(0);
              insertDataProd();
            }} className={styles.cadastroCliente}>
              PRODUZIR
            </button>
          </div>
        </div>
        {isModalOpenForm && (
          <div className={styles.modalProducaoForm}>
            <div className={styles.modalContentProducaoForm}>
              <div className={styles.closeForm} onClick={() => setIsModalOpenForm(false)}>&times; Fechar</div>
              <h2>Conteúdo da DS-160</h2>
              <p>{currentFormContent}</p>
            </div>
          </div>
        )}
        {isModalOpenAnalise && (
          <div className={styles.modalProducaoForm}>
            <div className={styles.modalContentProducaoForm}>
              <div className={styles.closeForm} onClick={() => setIsModalOpenAnalise(false)}>&times; Fechar</div>
              <h2>Conteúdo da Análise de Perfil</h2>
              <p>{currentAnaliseContent}</p>
            </div>
          </div>
        )}
        {/* // Dentro do bloco de exibição de comprovante */}
        {comprovanteEnviadoProd === true ? (
          <div className={`${styles.cadastroClienteContainer} ${styles.copiar}`}
            onClick={() => {
              var r = document.createRange();
              r.selectNode(document.getElementById('copiar3'));
              window.getSelection().removeAllRanges();
              window.getSelection().addRange(r);
              try {
                document.execCommand('copy');
                window.getSelection().removeAllRanges();
                console.log('Successfully copy text:' + r);
                setNotificationType(19);
              } catch (err) {
                console.log('Unable to copy!');
              }
            }}
          >
            <div className={styles.copiarTop}>
              COMPROVANTE (clica para copiar)
            </div>
            <p id='copiar3' className={styles.copiarText}>
              Nome: {comprovanteNome}
              <br />
              Contato: {comprovanteContato}
              <br />
              <br />
              Obs: {comprovanteObsProd}
              <div>
                {comprovanteAnalise === 1 && (
                  <div>
                    Fez análise de Perfil.
                    <br />
                  </div>
                )}
              </div>
              <br />
              <div>
                {comprovantePreenchendo === 1 && (
                  <div>
                    Já preencheu o Formulário.
                  </div>
                )}
              </div>
              {/* Links de Preenchimento dos Formulários */}
              <div>
                <p>Link para preenchimento dos formulários:</p>
                <a href={uniqueClientLink} target="_blank" rel="noopener noreferrer">
                  {uniqueClientLink}
                </a>
              </div>
              <br />
              Data de Cadastro: {dataCadastroComprovante}
            </p>
          </div>
        ) : <></>}
        <div className={styles.divisor}></div>
      </div>
    </div>
  );
}

export default Produzir;